module.exports = __webpack_public_path__ + "media/images/athletes/3556-d7e603131369b9c5bad00604665a2357.png";